// src/components/Itinerary/components/CruisesItinerary/components/MapView/styles.tsx
import { sva } from "@headout/pixie/css";
var mapViewStylesRecipe = sva({
  slots: [
    "root",
    "accordionHeader",
    "accordionBody",
    "accordionBodyOverride",
    "numberedMarkerIconContainer",
    "itineraryStopSwipeSheetWrapper",
    "itineraryMapSwipeSheetWrapper"
  ],
  base: {
    root: {
      position: "relative",
      zIndex: 1
    },
    accordionHeader: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer"
    },
    accordionBody: {
      height: "[27.625rem]",
      width: "[100%]",
      marginTop: "space.20"
    },
    numberedMarkerIconContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "[1.5rem]",
      width: "[1.5rem]",
      "& svg": {
        height: "[1.5rem]",
        width: "[1.5rem]"
      },
      "& p": {
        fontSize: "font.size.12",
        lineHeight: "lh.16",
        marginTop: "space.2 !important"
      }
    },
    itineraryStopSwipeSheetWrapper: {
      zIndex: 101,
      position: "relative"
    },
    itineraryMapSwipeSheetWrapper: {
      zIndex: 100,
      position: "relative"
    }
  }
});
var overrideStylesRecipe = sva({
  slots: ["mapContainer", "accordionItems", "legendContainer"],
  base: {
    mapContainer: {
      border: "[1px solid token(colors.core.grey.300)]",
      borderRadius: "radius.12",
      overflow: "hidden",
      background: "core.grey.100"
    },
    accordionItems: {
      padding: 0
    },
    legendContainer: {
      border: "none !important"
    }
  }
});

export {
  mapViewStylesRecipe,
  overrideStylesRecipe
};
